// extracted by mini-css-extract-plugin
export var addressFields = "_jj-0";
export var animationContainer = "_jj-1";
export var footer = "_jj-2";
export var lineItems = "_jj-3";
export var modalContent = "_jj-4";
export var orderName = "_jj-5";
export var strong = "_jj-6";
export var warning = "_jj-7";